<template>
  <section>
    <b-container
      fluid
      style="position: relative; margin: 4% 0 2%"
      class="scale-box"
      @mouseleave="Leave"
    >
      <b-row
        class="text-left justify-content-start left-wrap"
        v-if="dataList && dataList.length"
      >
        <b-col
          cols="12"
          class="text-left justify-content-start d-flex link-work"
        >
          <b-container fluid style="padding: 2% 1%">
            <b-row class="text-left justify-content-start link_box">
              <b-col
                cols="6"
                md="4"
                lg="3"
                class="text-left justify-content-start d-flex"
                v-for="(item, index) in dataList"
                :key="index"
              >
                <!-- style="background-color: aqua;" -->
                <span class="link-text" @click="goLink(item.linkUrl)">{{
                  item.name
                }}</span>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="text-center justify-content-center link-wrap">
        <!-- style="position: absolute; top: -20px; left: 0; width: 100%" -->
        <b-col cols="4" class="text-center justify-content-center d-flex">
          <div class="item-link link-mr" @mouseenter="goType(1)">
            <span class="link-title" :style="flag1 ? colorStyle : ''"
              >国家部委网站</span
            >
          </div>
        </b-col>

        <b-col cols="4" class="text-center justify-content-center d-flex">
          <div class="item-link link-mc" @mouseenter="goType(2)">
            <span class="link-title" :style="flag2 ? colorStyle : ''"
              >地方管理局</span
            >
          </div>
        </b-col>

        <b-col cols="4" class="text-center justify-content-center d-flex">
          <div class="item-link link-ml" @mouseenter="goType(3)">
            <span class="link-title" :style="flag3 ? colorStyle : ''"
              >更多行业单位</span
            >
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
export default {
  data() {
    return {
      OneList: [],
      TwoList: [],
      ThreeList: [],
      flag1: false,
      flag2: false,
      flag3: false,
      showFlag: false,
      dataList: [],
      colorStyle: {
        color: "rgb(6, 101, 234)",
      },
    };
  },
  created() {
    this.getLinkList();
  },
  methods: {
    getLinkList() {
      this.OneList = [
        {
          id: "01",
          name: "中华人民共和国交通运输部",
          linkUrl: "https://www.mot.gov.cn/",
        },
        {
          id: "02",
          name: "中国民用航空局",
          linkUrl: "http://www.caac.gov.cn/GYMH/",
        },
      ];
      this.TwoList = [
        {
          id: "01",
          name: "华北地区管理局",
          linkUrl: "http://hb.caac.gov.cn/",
        },
        {
          id: "02",
          name: "东北地区管理局",
          linkUrl: "http://db.caac.gov.cn/",
        },
        {
          id: "03",
          name: "华东地区管理局",
          linkUrl: "http://hd.caac.gov.cn/",
        },
        {
          id: "04",
          name: "中南地区管理局",
          linkUrl: "http://zn.caac.gov.cn/",
        },
        {
          id: "05",
          name: "西南地区管理局",
          linkUrl: "http://xn.caac.gov.cn/",
        },
        {
          id: "06",
          name: "西北地区管理局",
          linkUrl: "http://xb.caac.gov.cn/",
        },
        {
          id: "07",
          name: "新疆管理局",
          linkUrl: "http://xj.caac.gov.cn/",
        },
      ];
      this.ThreeList = [
        {
          id: "01",
          name: "空中交通管理局",
          linkUrl: "http://www.atmb.net.cn/",
        },
        {
          id: "02",
          name: "机关服务局",
          linkUrl:
            "http://www.caac.gov.cn/website/G1/jsjg_new/201602/t20160223_85583.html",
        },
        {
          id: "03",
          name: "中国民航大学",
          linkUrl: "https://www.cauc.edu.cn/zhv4/",
        },
        {
          id: "04",
          name: "中国民航飞行学院",
          linkUrl: "http://www.cafuc.edu.cn/",
        },
        {
          id: "05",
          name: "中国民航管理干部学院",
          linkUrl: "http://www.camic.cn/",
        },
        {
          id: "06",
          name: "中国民航科学技术研究院",
          linkUrl: "http://www.castc.org.cn/",
        },
        {
          id: "07",
          name: "民航第二研究所",
          linkUrl: "http://www.caacsri.com/",
        },
        {
          id: "08",
          name: "中国民航报社出版社",
          linkUrl: "http://www.caacnews.com.cn/",
        },
        {
          id: "09",
          name: "民航医学中心（总医院）",
          linkUrl: "https://www.mhzyy.cn/",
        },
        {
          id: "10",
          name: "清算中心",
          linkUrl: "http://www.caacsc.cn/difuwz/app/gonggxxll/login/doNew.htm",
        },
        {
          id: "11",
          name: "中国民航飞行校验中心",
          linkUrl: "http://www.chinacfi.net/",
        },

        {
          id: "12",
          name: "民航专业工程质量监督总站",
          linkUrl: "http://www.caqs.cn/",
        },
        {
          id: "13",
          name: "首都机场集团",
          linkUrl: "http://www.cah.com.cn/index.jspx",
        },
        {
          id: "14",
          name: "审计中心",
          linkUrl: "http://sjzx.caac.gov.cn/",
        },
        {
          id: "15",
          name: "国际合作中心",
          linkUrl: "http://www.icscc.org.cn/",
        },
        {
          id: "16",
          name: "中国民航机场建设集团公司",
          linkUrl: "http://www.buildhr.com/topic/130221/",
        },
        {
          id: "17",
          name: "中国民航工程咨询公司",
          linkUrl: "https://chinacaec.dlzb.com/",
        },
        {
          id: "18",
          name: "中国民用航空发动机适航审定中心",
          linkUrl: "http://www.caac.gov.cn/website/dev/ACC",
        },
        {
          id: "19",
          name: "民航博物馆",
          linkUrl: "http://www.caacmuseum.cn/Museum/Default.aspx",
        },
      ];
    },
    Leave() {
      this.dataList = [];
    },
    goType(num) {
      switch (num) {
        case 1:
          this.flag1 = true;
          this.flag2 = false;
          this.flag3 = false;

          this.dataList = this.OneList;
          break;
        case 2:
          this.flag2 = true;
          this.flag1 = false;
          this.flag3 = false;
          this.dataList = this.TwoList;
          break;
        case 3:
          this.flag3 = true;
          this.flag1 = false;
          this.flag2 = false;
          this.dataList = this.ThreeList;
          break;
      }

      // if (this.showFlag){
      //   this.showFlag = false;
      //   this.dataList = []
      // }else{
      //   this.showFlag = true;
      // }
      console.log("23213", this.showFlag, this.dataList.length);
    },
    goLink(url) {
      if (!url) return false;
      else {
        window.open(url);
        // window.location.href = url
      }
    },
  },
};
</script>
<style>
@import "../../../assets/css/work.css";
</style>
<style lang="less" scoped>
.works_box {
  /* padding: 3% 0; */
}
@media (max-width: 575px) {
  .link-title {
    font-size: 13px;
  }
  .link-text {
    font-size: 12px;
    font-family: "PingFang Bold";
    color: #333;
    line-height: 2.582;
    margin: 0 20px 0 0;
  }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .link-text {
    font-size: 13px;
    line-height: 2.582;
  }
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .link-text {
    font-size: 13px;
    line-height: 2.582;
  }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  /* .link-text {
    font-size: 13px;
    line-height: 2.582;
  } */
  .link-text {
    font-size: 14px;
    line-height: 2.582;
  }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) and (max-width: 1440px) {
  .link-text {
    font-size: 13px;
    line-height: 2.582;
  }
}
@media (min-width: 1300px) and (max-width: 1440px) {
  .link-text {
    font-size: 14px;
    line-height: 2.582;
  }
}
@media (min-width: 1600px) {
}
</style>
